/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './MarketplaceListingEditorRpc';
import * as Queries from './MarketplaceListingEditorRpc.dfc.new';
import type { AdditionalContextArgs } from './MarketplaceListingEditorRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetDetailsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetDetailsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getDetails', References.GetDetailsResponseType>
        : References.GetDetailsResponseType)
    | undefined;
};

export function useGetDetailsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetDetailsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetDetailsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_DETAILS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getDetails: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetDetailsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetDetailsQueryReturn<T>;
}

type UseGetDetailsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetDetailsResponseType>,
    {},
    T extends true
      ? Record<'getDetails', References.GetDetailsResponseType>
      : References.GetDetailsResponseType
  >;

export function useGetDetailsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetDetailsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetDetailsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_DETAILS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getDetails: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetDetailsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetDetailsLazyQueryReturn<T>;
}

type UseGetDetailsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<Record<'result', References.GetDetailsResponseType>>,
  'data'
> & {
  data: T extends true
    ? Record<'getDetails', References.GetDetailsResponseType>
    : References.GetDetailsResponseType;
};

export function useGetDetailsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetDetailsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetDetailsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_DETAILS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getDetails: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetDetailsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetDetailsSuspenseQueryReturn<T>;
}

type UseGetListingSummariesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetListingSummariesResponseType>,
    References.GetListingSummariesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingSummaries',
            References.GetListingSummariesResponseType
          >
        : References.GetListingSummariesResponseType)
    | undefined;
};

export function useGetListingSummariesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingSummariesResponseType>,
    References.GetListingSummariesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSummariesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_SUMMARIES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSummaries: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSummariesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSummariesQueryReturn<T>;
}

type UseGetListingSummariesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingSummariesResponseType>,
    References.GetListingSummariesRequestType,
    T extends true
      ? Record<
          'getListingSummaries',
          References.GetListingSummariesResponseType
        >
      : References.GetListingSummariesResponseType
  >;

export function useGetListingSummariesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingSummariesResponseType>,
    References.GetListingSummariesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSummariesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_SUMMARIES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSummaries: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingSummariesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingSummariesLazyQueryReturn<T>;
}

type UseGetListingSummariesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingSummariesResponseType>,
    References.GetListingSummariesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getListingSummaries', References.GetListingSummariesResponseType>
    : References.GetListingSummariesResponseType;
};

export function useGetListingSummariesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingSummariesResponseType>,
    References.GetListingSummariesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSummariesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_SUMMARIES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingSummaries: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSummariesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSummariesSuspenseQueryReturn<T>;
}

type UseGetListingSummariesPageQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetListingSummariesPageResponseType>,
    References.GetListingSummariesPageRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingSummariesPage',
            References.GetListingSummariesPageResponseType
          >
        : References.GetListingSummariesPageResponseType)
    | undefined;
};

export function useGetListingSummariesPageQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingSummariesPageResponseType>,
    References.GetListingSummariesPageRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSummariesPageQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_SUMMARIES_PAGE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSummariesPage: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSummariesPageQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSummariesPageQueryReturn<T>;
}

type UseGetListingSummariesPageLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingSummariesPageResponseType>,
    References.GetListingSummariesPageRequestType,
    T extends true
      ? Record<
          'getListingSummariesPage',
          References.GetListingSummariesPageResponseType
        >
      : References.GetListingSummariesPageResponseType
  >;

export function useGetListingSummariesPageLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingSummariesPageResponseType>,
    References.GetListingSummariesPageRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSummariesPageLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_SUMMARIES_PAGE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSummariesPage: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingSummariesPageLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingSummariesPageLazyQueryReturn<T>;
}

type UseGetListingSummariesPageSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingSummariesPageResponseType>,
    References.GetListingSummariesPageRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getListingSummariesPage',
        References.GetListingSummariesPageResponseType
      >
    : References.GetListingSummariesPageResponseType;
};

export function useGetListingSummariesPageSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingSummariesPageResponseType>,
    References.GetListingSummariesPageRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSummariesPageSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_SUMMARIES_PAGE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingSummariesPage: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSummariesPageSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSummariesPageSuspenseQueryReturn<T>;
}

type UseGetDraftListingQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetDraftListingResponseType>,
    References.GetDraftListingRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getDraftListing', References.GetDraftListingResponseType>
        : References.GetDraftListingResponseType)
    | undefined;
};

export function useGetDraftListingQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetDraftListingResponseType>,
    References.GetDraftListingRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetDraftListingQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_DRAFT_LISTING_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getDraftListing: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetDraftListingQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetDraftListingQueryReturn<T>;
}

type UseGetDraftListingLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetDraftListingResponseType>,
    References.GetDraftListingRequestType,
    T extends true
      ? Record<'getDraftListing', References.GetDraftListingResponseType>
      : References.GetDraftListingResponseType
  >;

export function useGetDraftListingLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetDraftListingResponseType>,
    References.GetDraftListingRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetDraftListingLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_DRAFT_LISTING_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getDraftListing: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetDraftListingLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetDraftListingLazyQueryReturn<T>;
}

type UseGetDraftListingSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetDraftListingResponseType>,
    References.GetDraftListingRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getDraftListing', References.GetDraftListingResponseType>
    : References.GetDraftListingResponseType;
};

export function useGetDraftListingSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetDraftListingResponseType>,
    References.GetDraftListingRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetDraftListingSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_DRAFT_LISTING_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getDraftListing: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetDraftListingSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetDraftListingSuspenseQueryReturn<T>;
}
